import createAccentInsensitiveRegex from '../createAccentInsensitiveRegex.js';

export default {
  getPathExpression: (path, value, isNegated) => {
    if (isNegated) {
      return {
        [path.join('.')]: {
          $not: {
            $regex: '^' + createAccentInsensitiveRegex(value),
            $options: 'i'
          }
        }
      };
    } else {
      return {
        [path.join('.')]: {
          $regex: '^' + createAccentInsensitiveRegex(value),
          $options: 'i'
        }
      };
    }
  }
};
